export default (theme) => {
  return {
    formControlRoot: ({ noHelper }) => ({
      maxWidth: '100%',
      marginBottom: noHelper ? 0 : theme.spacing(4),
    }),

    inputLabelRoot: {
      top: theme.spacing(-1),
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      transition: '150ms all ease',
      '&.MuiInputLabel-shrink': {
        // because the label was scaled to 75%
        // and add 5% more
        width: '130%',
      },
    },

    formHelperTextRoot: {
      position: 'absolute',
      top: theme.spacing(4),
    },
  }
}
